import { render, staticRenderFns } from "./xdkmk.vue?vue&type=template&id=1988adce&"
import script from "./xdkmk.vue?vue&type=script&lang=js&"
export * from "./xdkmk.vue?vue&type=script&lang=js&"
import style0 from "./xdkmk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports